'use strict';

class OperationTypesController {
  /* @ngInject */
  constructor(OperationTypesService, $scope, $q) {
    Object.assign(this, { OperationTypesService, $scope, $q });

    this.query = {
      limit: 25,
      page: 1
    };
    //this.operationTypes = $scope.$parent.$resolve.operationTypes;
    this.getOperationTypes();

    this.onPagination = () => {
      this.getOperationTypes();
    };

    this.clientIds = null;
  }

  getOperationTypes() {
    let opts = {
      page: this.query.page,
      limit: this.query.limit,
      where: {},
      include: []
    };

    let queryReady = this.OperationTypesService.getModels(opts).then(
      operationTypes => {
        this.operationTypes = operationTypes;
      }
    );
    let countReady = this.OperationTypesService.getCount(opts).then(result => {
      this.operationTypesCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default OperationTypesController;
